var exports = {
  "k": "x2b2fbebb--3287d5--container",
  "N": "x2b2fbebb--3287d5--container-experimental",
};

module.exports = exports;
